import Vue from 'vue';
import overview from '../../mixins/overview.js';
import transition_staggered_fade from '../../mixins/transition-staggered-fade-mixin.js';

Vue.component('overview-filtercat-block', {
    mixins: [overview, transition_staggered_fade],
    data: function() {
        return {
            loadItems: 200,
            types: [],
            itemsPerPage: 12
        };
    },

    computed: {
        pages: function() {
            if (this.filteredResults.length % this.itemsPerPage == 0) {
                return this.filteredResults.length / this.itemsPerPage;
            }
            return Math.ceil(this.filteredResults.length / this.itemsPerPage);
        },

        options: function() {
            return this.searchResults.reduce((categories, result) => {
                categories.filter(category => {
                    return category.value == result.ParentId;
                }).length == 0
                    ? categories.push({
                          label: result.ParentName,
                          value: result.ParentId
                      })
                    : null;
                return categories;
            }, []);
        },
        filteredResults: function() {
            if (this.types.length > 0) {
                return this.searchResults.filter(result => {
                    return this.types.includes(result.ParentId);
                });
            }
            return this.searchResults;
        },
        pageResults: function() {
            return this.filteredResults.slice(
                this.currentPage * this.itemsPerPage - this.itemsPerPage,
                this.currentPage * this.itemsPerPage
            );
        },

        typesObj: function() {
            const obj = {};
            this.types.forEach(item => {
                obj[item] = true;
            });
            return obj;
        }
    },

    watch: {
        currentPage: function() {}
    },

    methods: {
        toggleFilter: function(filter) {
            this.currentPage = 1;
            !(this.types.indexOf(filter) != -1)
                ? this.types.push(filter)
                : this.types.splice(this.types.indexOf(filter), 1);
        },

        currentPageWatcher: function() {}
    }
});
